<div class="layout-main">
  <app-header></app-header>
  <app-contact></app-contact>
  <ng-content></ng-content>
  <app-footer></app-footer>
</div>